import { ApplicationState } from './application-state.interface';

export const initialState: ApplicationState = {
    isExpanded: false,
    userMode: 'default',
    searchQuery: '',
    searchFocus: false
}